import { nameof } from "ts-simple-nameof";
import { DefaultInputField } from "../../common/components/forms/inputs/InputField/DefaultInputField";
import { useNewPasswordPage } from "./hooks/useNewPasswordPage";
import { INewPasswordFormModel } from "./models/newPasswordFormModel";
import styles from "./NewPassword.module.scss";
import { DefaultButton } from "../../common/components/button/defaultButton/DefaultButton";
import { FormProvider } from "react-hook-form";
import { HiddenField } from "../../common/components/forms/inputs/hiddenField/HiddenField";
import { FloatingPanel } from "../../common/components/common/FloatingPanel/FloatingPanel";

export const NewPassword = () => {
  const { form, isMobile, submit, isValidating, phoneNumber } = useNewPasswordPage();
  const inputMaxWidth = isMobile ? "100%" : "300px";

  if (isValidating) {
    return null;
  }

  return (
    <FloatingPanel
      title="Задаване на нова парола"
      className={styles.root}
      variant="glass"
    >
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(submit)} className={styles.root_content}>
          <div className={styles.root_fields}>
            <HiddenField name={nameof<INewPasswordFormModel>((x) => x.token)} />
            <HiddenField name={nameof<INewPasswordFormModel>((x) => x.email)} />

            {phoneNumber && (
              <input
                type="text"
                name="username"
                autoComplete="username"
                value={phoneNumber}
                readOnly
                aria-hidden="true"
                style={{ position: "absolute", opacity: 0, pointerEvents: "none", width: 0, height: 0 }}
              />
            )}

            <DefaultInputField
              name={nameof<INewPasswordFormModel>((x) => x.newPassword)}
              label="Нова парола"
              placeholder="******"
              type="password"
              width={inputMaxWidth}
              autocomplete="new-password"
            />

            <DefaultInputField
              name={nameof<INewPasswordFormModel>((x) => x.repeatNewPassword)}
              label="Повторете новата парола"
              placeholder="******"
              type="password"
              width={inputMaxWidth}
              autocomplete="new-password"
            />
          </div>

          <div className={styles.root_buttons}>
            <DefaultButton label={"Запази"} type="submit" design="accent" />
            <p
              className={styles.root_buttons_disclaimer}
              style={{ maxWidth: inputMaxWidth }}
            >
              Паролата трябва да съдържа поне една буква, един символ и една цифра.
            </p>
          </div>
        </form>
      </FormProvider>
    </FloatingPanel>
  );
};
